{
  "title": {
    "create": "Terrain erstellen",
    "edit": "Terrain bearbeiten"
  },
  "name": "Name",
  "bounds": "Grenzen",
  "tiles": "Kacheln",
  "remove_tiles": "Kacheln entfernen",
  "Pending": "Ausstehend",
  "Active": "Aktiv",
  "Deleted": "Gelöscht",
  "terrain_options": "Klicken Sie hier, um die Geländeoptionen zu öffnen",
  "edit": "Terrain bearbeiten",
  "delete": "Terrain löschen",
  "uploading_tiles": "Kacheln hochladen"
}